import { render, staticRenderFns } from "./DeleteAlertModal.vue?vue&type=template&id=6521a23b&"
import script from "./DeleteAlertModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports